import { CONCIERGE_TYPES, ConciergeType } from '@/store/constant'
import { Concierge } from '@/types/concierge'
import { createContext } from 'react'

interface ConciergeListContextType {
  conciergesList: Concierge[]
  selectedConcierge: Concierge | null
  setSelectedConcierge: (concierge: Concierge) => void
  conciergeType: ConciergeType
  setConciergeType: (type: ConciergeType) => void
}

export const ConciergeListContext = createContext<ConciergeListContextType>({
  conciergesList: [],
  selectedConcierge: null,
  setSelectedConcierge: () => {},
  conciergeType: CONCIERGE_TYPES.WEB_WISDOM,
  setConciergeType: () => {},
})
